<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p class="summary-text">{{data.detail}}</p>
</div>
<div mat-dialog-actions>
  <button *ngIf='showCancel' mat-button [mat-dialog-close]="false">{{data.cancel}}</button>
  <div *ngIf='!showCancel' class="filler"></div>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.accept}}</button>
</div>